import Constants from '@/constants/const';
import nookies from 'nookies';
/**
 * 获取cookies
 * @param key
 * @param ctx client端为空
 */
export const getCookie = (key: string, ctx?) => {
  const cookies = nookies.get(ctx || {}) || {};
  return cookies[key];
};

/**
 * 获取直邮满运费门槛，比如满49/35
 */
export const getShippingFreeFee = (ctx?) => {
  return getCookie(Constants.PANTRY_FREE_FEE, ctx);
};
